$(document).ready(function(){  
  $('.category-section-flex').each(function(){
    var current_collection = $(this).attr('id');
    $('#'+current_collection+' .category-main').not('.slick-initialized').slick({
      infinite: true,
      slidesToShow: 4,
      slidesToScroll:1,
      dots: false,
      centerMode: false,
      centerPadding:'60px',
      appendArrows: $('#'+current_collection+' .category__arrows'),
      prevArrow: `<button class="block__category-arrow slick-arrow prev-arrow"><svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M23 8H1" stroke="#59315F" stroke-opacity="0.5" stroke-width="1.5" stroke-linecap="round"/><path d="M8 1L1 8L8 15" stroke="#59315F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>`,
      nextArrow: `<button class="block__category-arrow slick-arrow next-arrow"><svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M1 8H23" stroke="#59315F" stroke-opacity="0.5" stroke-width="1.5" stroke-linecap="round"/><path d="M16 1L23 8L16 15" stroke="#59315F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>`,
      responsive: [{
        breakpoint: 1550,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          centerMode: false,
          centerPadding:'75px'
        }
      }, 
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          centerMode: false,
          centerPadding:'55px'
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          centerMode: false,
          centerPadding:'25px',
          arrows: true
        }
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false,
          centerPadding:'40px',
          arrows: true          
        }
      }
     ] 
    });
}); 


    $(".review-shopthelook-section-left .review-shopthelook-section-block").slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      autoplay: true,
      fade: true,
      arrows: false
    });


  $(".shop-the-look-section .collection-featured-grid").slick({
      infinite: true,
      slidesToShow:1,
      slidesToScroll: 1,
      dots: false,
      centerMode: true,
      centerPadding:'40px',
      prevArrow: `<button class="block__category-arrow slick-arrow prev-arrow"><svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M23 8H1" stroke="#59315F" stroke-opacity="0.5" stroke-width="1.5" stroke-linecap="round"/><path d="M8 1L1 8L8 15" stroke="#59315F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>`,
      nextArrow: `<button class="block__category-arrow slick-arrow next-arrow"><svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M1 8H23" stroke="#59315F" stroke-opacity="0.5" stroke-width="1.5" stroke-linecap="round"/><path d="M16 1L23 8L16 15" stroke="#59315F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>`,    
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            centerMode: false,
            centerPadding:'0',            
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            centerMode: false,
            centerPadding:'0',
            appendArrows: $('.shop-the-look-collection__arrows_mobile')
          }
        }
      ]
  });

  
    $(".best-sellar-collection .category-main.category-main-area-best-sellers").slick({
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        dots: false,
        centerMode: false,
        centerPadding:'0',
        appendArrows: $('.best-seller-collection__arrows'),
        prevArrow: `<button class="block__category-arrow slick-arrow prev-arrow"><svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M23 8H1" stroke="#59315F" stroke-opacity="0.5" stroke-width="1.5" stroke-linecap="round"/><path d="M8 1L1 8L8 15" stroke="#59315F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>`,
        nextArrow: `<button class="block__category-arrow slick-arrow next-arrow"><svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M1 8H23" stroke="#59315F" stroke-opacity="0.5" stroke-width="1.5" stroke-linecap="round"/><path d="M16 1L23 8L16 15" stroke="#59315F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>`,
        responsive: [{
          breakpoint: 1550,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            centerMode: false
          }
        },
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            centerMode: false
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding:'75px'
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding:'25px'
          }
        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding:'45px',
             appendArrows: $('.best-seller-collection__arrows-mobile'),
          }
        }
        ]
      });
  
// Featured Product Js
  $(':not(.section-featured-inner-grid).featured-collection-main-flex').each(function(){
    var featured_collection = $(this).attr('id');    
    $('#'+featured_collection+' .collection-featured-grid').slick({
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      dots: false,
      appendArrows: $('#'+featured_collection+' .featured-collection__arrows'),
      prevArrow: `<button class="block__category-arrow slick-arrow prev-arrow"><svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M23 8H1" stroke="#59315F" stroke-opacity="0.5" stroke-width="1.5" stroke-linecap="round"/><path d="M8 1L1 8L8 15" stroke="#59315F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>`,
      nextArrow: `<button class="block__category-arrow slick-arrow next-arrow"><svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M1 8H23" stroke="#59315F" stroke-opacity="0.5" stroke-width="1.5" stroke-linecap="round"/><path d="M16 1L23 8L16 15" stroke="#59315F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>`,
      responsive: [{
        breakpoint: 1400,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding:'75px'
        }
      },
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding:'35px'
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding:'45px'
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          appendArrows: $('#'+featured_collection+' .featured-collection__arrows_mobile')
        }
      }
    ]
    });
  });
  
$(".block__card-product--slider .collection-featured-grid").slick({
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      prevArrow: `<button class="block__category-arrow collection-filter-arrow-prev slick-arrow prev-arrow"><svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M23 8H1" stroke="#59315F" stroke-opacity="0.5" stroke-width="1.5" stroke-linecap="round"/><path d="M8 1L1 8L8 15" stroke="#59315F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>`,
      nextArrow: `<button class="block__category-arrow collection-filter-arrow-next slick-arrow next-arrow"><svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M1 8H23" stroke="#59315F" stroke-opacity="0.5" stroke-width="1.5" stroke-linecap="round"/><path d="M16 1L23 8L16 15" stroke="#59315F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>`,
      responsive: [{
        breakpoint: 1400,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding:'75px'
        }
      },
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding:'35px'
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding:'45px'
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
}); 

$('.block__multicollection--productwrapper.slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.block__multicollection-tabcontent.slider-nav',
 });
  
$('.block__multicollection-tabcontent.slider-nav').slick({
    slidesToShow: 7,
    slidesToScroll: 1,
    asNavFor: '.block__multicollection--productwrapper.slider-for',
    dots: false,
    centerMode: true,
    focusOnSelect: true,  
    arrows: true,
    prevArrow: `<button class="block__category-arrow collection-filter-arrow-prev slick-arrow prev-arrow"><svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M23 8H1" stroke="#59315F" stroke-opacity="0.5" stroke-width="1.5" stroke-linecap="round"/><path d="M8 1L1 8L8 15" stroke="#59315F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>`,
    nextArrow: `<button class="block__category-arrow collection-filter-arrow-next slick-arrow next-arrow"><svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M1 8H23" stroke="#59315F" stroke-opacity="0.5" stroke-width="1.5" stroke-linecap="round"/><path d="M16 1L23 8L16 15" stroke="#59315F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>`,
    responsive: [{
            breakpoint: 992,
            settings: {
              slidesToShow: 5,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 5,
              slidesToScroll: 1,
              centerMode: true,
              centerPadding:'35px'
            }
          },
           {
            breakpoint: 575,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              centerMode: true,
              centerPadding:'55px'
            }
          },
          {
            breakpoint: 400,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              centerMode: true,
              centerPadding:'50px'
            }
          }
      ]
});


  $(".our-recent-articale-blog-inners.our-recent-articale-blog-mobile").slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      centerMode: true,
      centerPadding:'25px',
      appendArrows: $('.our-latest-blogs__arrows'),
      prevArrow: `<button class="block__category-arrow slick-arrow prev-arrow"><svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M23 8H1" stroke="#59315F" stroke-opacity="0.5" stroke-width="1.5" stroke-linecap="round"/><path d="M8 1L1 8L8 15" stroke="#59315F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>`,
      nextArrow: `<button class="block__category-arrow slick-arrow next-arrow"><svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M1 8H23" stroke="#59315F" stroke-opacity="0.5" stroke-width="1.5" stroke-linecap="round"/><path d="M16 1L23 8L16 15" stroke="#59315F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>`
    });  

  $("#mobile_kit_content.more-from-this-collection .product-more-collection-inner").slick({
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 3,
      dots: false,
      appendArrows: $('#mobile_kit_content .product-more-collection-arrow'),
      prevArrow: `<button class="block__category-arrow slick-arrow prev-arrow"><svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M23 8H1" stroke="#59315F" stroke-opacity="0.5" stroke-width="1.5" stroke-linecap="round"/><path d="M8 1L1 8L8 15" stroke="#59315F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>`,
      nextArrow: `<button class="block__category-arrow slick-arrow next-arrow"><svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M1 8H23" stroke="#59315F" stroke-opacity="0.5" stroke-width="1.5" stroke-linecap="round"/><path d="M16 1L23 8L16 15" stroke="#59315F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>`,
      responsive: [
        {
          breakpoint:750,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding:'20px',
             infinite: true
          }
        }
      ]
    });
  $("#desktop_kit_content.more-from-this-collection .product-more-collection-inner").slick({
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 3,
      dots: false,
      appendArrows: $('#desktop_kit_content .product-more-collection-arrow'),
      prevArrow: `<button class="block__category-arrow slick-arrow prev-arrow"><svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M23 8H1" stroke="#59315F" stroke-opacity="0.5" stroke-width="1.5" stroke-linecap="round"/><path d="M8 1L1 8L8 15" stroke="#59315F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>`,
      nextArrow: `<button class="block__category-arrow slick-arrow next-arrow"><svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M1 8H23" stroke="#59315F" stroke-opacity="0.5" stroke-width="1.5" stroke-linecap="round"/><path d="M16 1L23 8L16 15" stroke="#59315F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>`,
      responsive: [
        {
          breakpoint:750,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        }
      ]
    });

  
    $('.block__video-instructions-inner').slick({
      centerMode: true,
      centerPadding: '125px',
      slidesToShow: 2,
      prevArrow: `<button class="block__category-arrow collection-filter-arrow-prev slick-arrow prev-arrow"><svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M23 8H1" stroke="#59315F" stroke-opacity="0.5" stroke-width="1.5" stroke-linecap="round"/><path d="M8 1L1 8L8 15" stroke="#59315F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>`,
      nextArrow: `<button class="block__category-arrow collection-filter-arrow-next slick-arrow next-arrow"><svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M1 8H23" stroke="#59315F" stroke-opacity="0.5" stroke-width="1.5" stroke-linecap="round"/><path d="M16 1L23 8L16 15" stroke="#59315F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>`,
    responsive: [
        {
          breakpoint: 1200,
          settings: {
            centerMode: true,
            centerPadding: '60px',
            slidesToShow: 2
          }
        },
        {
          breakpoint: 992,
          settings: {
            centerMode: true,
            centerPadding: '90px',
            slidesToShow: 1
          }
        },
        {
          breakpoint: 576,
          settings: {
            centerMode: true,
            centerPadding: '20px',
            slidesToShow: 1,
            appendArrows: $('.video_arrows-arrows-mobile')
          }
        }
      ]
    });
// finishing-ideas
  $('.section-finishing-inner .section-finishing-flex').slick({
      centerMode: true,
      centerPadding: '450px',
      slidesToShow: 1,
      prevArrow: `<button class="block_finishing-arrows slick-arrow prev-arrow"><svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M23 8H1" stroke="#59315F" stroke-opacity="0.5" stroke-width="1.5" stroke-linecap="round"/><path d="M8 1L1 8L8 15" stroke="#59315F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>`,
      nextArrow: `<button class="block_finishing-arrows slick-arrow next-arrow"><svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M1 8H23" stroke="#59315F" stroke-opacity="0.5" stroke-width="1.5" stroke-linecap="round"/><path d="M16 1L23 8L16 15" stroke="#59315F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>`,
      responsive: [
          {
            breakpoint: 1550,
            settings: {
              centerPadding: '300px'
            }
          },
          {
            breakpoint: 1300,
            settings: {
              centerPadding: '150px'
            }
          },
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 1,
              centerMode: true,
              centerPadding: '150px'
            }
          },
          {
            breakpoint: 576,
            settings: {
                slidesToShow: 1,
                centerMode: true,
                centerPadding: '35px',
                appendArrows: $('.finishing_arrows-arrows-mobile')
            }
          }
          
        ]
    }); 


    $('.product--thumbnail_slider .product__media-list').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      adaptiveHeight: true,
      prevArrow: `<button class="slick-arrow prev-arrow"><svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 1L1 8L8 15" stroke="#59315F" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>`,
      nextArrow: `<button class="slick-arrow next-arrow"><svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L8 8L1 15" stroke="#59315F" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>`,
      asNavFor: '.thumbnail-slider .thumbnail-list.slider--tablet-up'
    });
    $('.thumbnail-slider .thumbnail-list.slider--tablet-up').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      asNavFor: '.product--thumbnail_slider .product__media-list',
      dots: false,
      centerMode: false,
      focusOnSelect: true,
      arrows: true,
      prevArrow: `<button class="slick-arrow prev-arrow"><svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 1L1 8L8 15" stroke="#59315F" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>`,
      nextArrow: `<button class="slick-arrow next-arrow"><svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L8 8L1 15" stroke="#59315F" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>`,
      responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 4
            }
          }
        ]
      });
}); 